import React, { FunctionComponent } from 'react';
import { Button } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import AuthResult from '../layout/AuthResult';
import { useResendCountdown } from './useResendCountdown';
import styles from './authForm.module.scss';

interface SentResultProps {
  email: string;
  /** Klucz tekstu z `<b>{{email}}</b>`: link do logowania albo do zmiany hasła. */
  textKey: string;
  resendLabel: string;
  onResend: () => Promise<void>;
  /** Powrót do formularza z wpisanym adresem (pomyłka w adresie). */
  onFixAddress: () => void;
}

/** „Sprawdź skrzynkę” w karcie: adres w treści, ponowna wysyłka po odliczaniu, podpowiedź o Spamie. */
const SentResult: FunctionComponent<SentResultProps> = ({
  email,
  textKey,
  resendLabel,
  onResend,
  onFixAddress,
}) => {
  const { t } = useTranslation('auth');
  const { remaining, restart } = useResendCountdown();

  const resend = async () => {
    restart();
    await onResend();
  };

  return (
    <AuthResult
      tone="sent"
      title={t('auth:screens.link.sentTitle')}
      text={<Trans t={t} i18nKey={textKey} values={{ email }} components={{ b: <b /> }} />}
      actions={
        <Button block disabled={remaining > 0} onClick={resend}>
          {resendLabel}
          {remaining > 0 && ` ${t('auth:screens.sent.countdown', { seconds: remaining })}`}
        </Button>
      }
      note={
        <Trans
          t={t}
          i18nKey="auth:screens.sent.spamHint"
          components={{
            fix: <button type="button" className={styles.inlineLink} onClick={onFixAddress} />,
          }}
        />
      }
    />
  );
};

export default SentResult;
